import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import ReactPaginate from 'react-paginate';

import Grid from "@mui/material/Grid";

import Typography from "@mui/material/Typography";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import { GetPartyList } from "~slices/Party";
import { getLocalStorage } from "../../stores/Information";
import { formatDate, formatTime } from "~/functions/FormatDate";

const PartyList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const informationState = useSelector((state) => state.Information);
    const party_state = useSelector((state) => state.Party);
    const party_list = party_state.party_list;
    const search = useLocation().search;
    const query = new URLSearchParams(search);

    useEffect(() => {
        //ログインしていないならログイン画面へ
        if(!getLocalStorage("organizer"))
        {
            history.push(`/Login`);
            return;
        }

        if(informationState["organizer"]["user_login"] === true)
        {
            const page = query.get("page") ? query.get("page") : "1";
            get_PartyList(page);
        }
    }, [informationState]);

    //詳細
    const DetailClick = (party_data) => {
        //console.log(party_data);
        const params = {
            party_id: party_data.party_id,
            page: query.get("page") ? query.get("page") : "1"
        };
        const urlSearchParam = new URLSearchParams(params).toString();

        history.push(`/PartyDetail?${urlSearchParam}`);
    };

    
    //申込履歴取得
    const get_PartyList = (page) => {
        if(informationState["organizer"]["user_login"] === true)
        {
            const params = {
                organizer_id: informationState["organizer"]["organizer_id"],
                paginate: page
            };

            dispatch(GetPartyList(params)).then((data) => {
                const result = data.payload.result;
                if(result === 'NG')
                {
                    //NGメッセージ表示
                    alert(data.payload.message);
                    history.push(`/`);
                }
            }
            );
        }
    }

    //ページ切替
    const handlePaginate = (selectedItem) => {
        const page = selectedItem.selected + 1;

        const params = {
            page: page,
        };
        const urlSearchParam = new URLSearchParams(params).toString();
        history.push(`/PartyList?${urlSearchParam}`);
        get_PartyList(page);
        window.scroll({ top: 0, behavior: "smooth" });
      };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                お申込み履歴
            </Typography>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                {party_list?.data?.length ? (
                    <>
                        
                        {party_list.data.map((party_data, index) => (
                            <React.Fragment key={index}>
                                <Card
                                    sx={{
                                        width: "100%",
                                        // maxWidth: 600,
                                        // minWidth: 300,
                                        m: "0.5rem",
                                        // mt: "1rem",
                                        b: 1,

                                        borderRadius: 5,
                                    }}
                                >
                                    <Grid container>
                                        <Grid item xs>
                                            <CardContent>
                                                <Typography variant="h6" component="div">
                                                    {party_data.party_name}
                                                </Typography>
                                                <Typography variant="body1" component="div">
                                                    {formatDate(new Date(party_data.party_date), 'YYYY/MM/DD  (aa)')}　
                                                    {formatTime(new Date(party_data.party_date + ' ' + party_data.party_start_time))}～
                                                </Typography>

                                                <Typography variant="body2" component="div">
                                                    参加予定人数：{party_data.planned_number}人
                                                </Typography>
                                            </CardContent>
                                        </Grid>
                                        <Grid
                                            item
                                            sx={{
                                                bgcolor: "primary.main",
                                                color: "white",
                                                display: "grid",
                                                minWidth: "4rem",
                                            }}
                                        >
                                            <ButtonBase onClick={() => DetailClick(party_data)}>
                                                <CardActions>詳細</CardActions>
                                            </ButtonBase>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </React.Fragment>
                        ))}{" "}
                        <ReactPaginate
                            forcePage={party_list.current_page - 1} //現在表示しているページ
                            pageCount={party_list.last_page} //総ページ数
                            marginPagesDisplayed={5} //先頭と末尾に表示するページ数（1 2 3 4 5...16 17 18 19 20）
                            //pageRangeDisplayed={2} //現在のページの前後をいくつ表示させるか（未確認）
                            onPageChange={handlePaginate} //ページ切替時のイベント
                            previousLabel={'＜'}
                            nextLabel={'＞'}
                            //デザイン
                            containerClassName="pagination justify-center"
                            pageClassName="page-item"
                            pageLinkClassName="page-link rounded-full"
                            activeClassName="active"
                            activeLinkClassName="active"
                            previousClassName="page-item"
                            nextClassName="page-item"
                            previousLinkClassName="page-link"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                        />
                    </>
                ) : (
                    "お申込みの履歴がありません"
                )}
            </Grid>
        </React.Fragment>
    );
};

export default PartyList;
